import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

import SearchIcon from '@mui/icons-material/Search';
import VerifiedIcon from '@mui/icons-material/Verified';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PublicIcon from '@mui/icons-material/Public';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import HandshakeIcon from '@mui/icons-material/Handshake';

const Home = () => {
  return (
    <div className="home-page">

      {/* ───────────────── HERO ───────────────── */}
      <section
        className="hero"
        style={{
          // backgroundImage: `url('/header.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="hero-overlay"></div>

        <div className="container hero-container">
          <div className="hero-content">

            <span className="hero-badge">
              GLOBAL SOURCING & INTERNATIONAL TRADING
            </span>

            <h1 className="hero-title">
              Your Trusted Partner
              <br />
              <span>From Supplier to Destination</span>
            </h1>

            <p className="hero-subtitle">
              Annapurna Axis Trading Pvt. Ltd. helps businesses source
              products from trusted suppliers, manage quality inspection,
              packaging, shipping, customs coordination, and door-to-door
              delivery.
            </p>

            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary btn-lg">
                Request a Quote
              </Link>

              <Link to="/services" className="btn btn-secondary btn-lg">
                Explore Our Services
              </Link>
            </div>

            <div className="hero-trust">
              <div className="hero-trust-item">
                <VerifiedIcon />
                <span>Trusted Suppliers</span>
              </div>

              <div className="hero-trust-item">
                <VerifiedIcon />
                <span>Quality Inspection</span>
              </div>

              <div className="hero-trust-item">
                <VerifiedIcon />
                <span>Global Logistics</span>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ───────────────── TRUST STRIP ───────────────── */}
      <section className="trust-strip">
        <div className="container">
          <div className="trust-grid">

            <div className="trust-item">
              <SearchIcon className="trust-icon" />
              <div>
                <h4>Product Sourcing</h4>
                <p>Find reliable suppliers</p>
              </div>
            </div>

            <div className="trust-item">
              <FactCheckIcon className="trust-icon" />
              <div>
                <h4>Quality Inspection</h4>
                <p>Verify before shipment</p>
              </div>
            </div>

            <div className="trust-item">
              <Inventory2Icon className="trust-icon" />
              <div>
                <h4>Packaging</h4>
                <p>Safe & professional packing</p>
              </div>
            </div>

            <div className="trust-item">
              <LocalShippingIcon className="trust-icon" />
              <div>
                <h4>Global Delivery</h4>
                <p>Reliable shipping solutions</p>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ───────────────── ABOUT ───────────────── */}
      <section className="about-section">
        <div className="container">
          <div className="about-grid">

            <div className="about-image-column">
              <div className="about-image-box">
                <img
                  src="/logo.png"
                  alt="Annapurna Axis Trading"
                  className="about-logo"
                />
              </div>

              <div className="about-floating-card">
                <span className="floating-number">360°</span>
                <span className="floating-text">
                  Global Trade Support
                </span>
              </div>
            </div>

            <div className="about-text">

              <span className="section-label">
                ABOUT ANNAPURNA AXIS
              </span>

              <h2 className="section-heading">
                Making Global Trade
                <br />
                <span>Simple & Reliable</span>
              </h2>

              <p>
                Annapurna Axis Trading Pvt. Ltd. is a professional sourcing
                and international trading company dedicated to making global
                trade simple, reliable, and efficient.
              </p>

              <p>
                We help businesses source products from trusted suppliers,
                manage quality inspection and packaging, coordinate shipping
                and logistics, support customs clearance, and arrange
                door-to-door delivery.
              </p>

              <div className="about-highlights">

                <div className="highlight-item">
                  <VerifiedIcon />
                  <span>Trusted Supplier Network</span>
                </div>

                <div className="highlight-item">
                  <VerifiedIcon />
                  <span>Quality Inspection Support</span>
                </div>

                <div className="highlight-item">
                  <VerifiedIcon />
                  <span>International Logistics</span>
                </div>

                <div className="highlight-item">
                  <VerifiedIcon />
                  <span>Door-to-Door Delivery</span>
                </div>

              </div>

              <Link to="/about" className="btn btn-primary">
                Learn More About Us
              </Link>

            </div>
          </div>
        </div>
      </section>


      {/* ───────────────── SERVICES ───────────────── */}
      <section className="services-section">
        <div className="container">

          <span className="section-label center">
            WHAT WE DO
          </span>

          <h2 className="section-heading center">
            Complete Global Trading Solutions
          </h2>

          <p className="section-subtitle">
            From finding the right supplier to delivering products to your
            final destination, we manage the process with transparency and
            reliability.
          </p>

          <div className="services-grid">

            <div className="service-card">
              <div className="service-icon">
                <SearchIcon />
              </div>
              <h3>Product Sourcing</h3>
              <p>
                We help you find suitable products and trusted suppliers
                according to your requirements, specifications, and budget.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <FactCheckIcon />
              </div>
              <h3>Quality Inspection</h3>
              <p>
                We coordinate product inspection and quality verification
                before your goods are shipped.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <Inventory2Icon />
              </div>
              <h3>Packaging</h3>
              <p>
                Proper packaging solutions help protect your products during
                transportation and international handling.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <LocalShippingIcon />
              </div>
              <h3>Shipping & Logistics</h3>
              <p>
                We coordinate shipping and logistics to help move your
                products efficiently from supplier to destination.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <PublicIcon />
              </div>
              <h3>Customs Support</h3>
              <p>
                We assist with customs-related coordination to make the
                international trading process smoother.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <StorefrontIcon />
              </div>
              <h3>Amazon FBA Delivery</h3>
              <p>
                We provide China-to-Amazon FBA warehouse delivery solutions
                for businesses selling through Amazon.
              </p>
              <Link to="/services">
                Learn More →
              </Link>
            </div>

          </div>
        </div>
      </section>


      {/* ───────────────── HOW IT WORKS ───────────────── */}
      <section className="process-section">
        <div className="container">

          <span className="section-label center">
            HOW IT WORKS
          </span>

          <h2 className="section-heading center white-heading">
            From Supplier to Final Destination
          </h2>

          <p className="section-subtitle light-subtitle">
            A simple and transparent process designed to make international
            sourcing easier for your business.
          </p>

          <div className="process-grid">

            <div className="process-item">
              <div className="process-number">01</div>
              <SearchIcon />
              <h3>Source</h3>
              <p>
                Find products and connect with suitable suppliers.
              </p>
            </div>

            <div className="process-item">
              <div className="process-number">02</div>
              <FactCheckIcon />
              <h3>Inspect</h3>
              <p>
                Verify product quality and specifications.
              </p>
            </div>

            <div className="process-item">
              <div className="process-number">03</div>
              <Inventory2Icon />
              <h3>Pack</h3>
              <p>
                Prepare and package goods securely.
              </p>
            </div>

            <div className="process-item">
              <div className="process-number">04</div>
              <LocalShippingIcon />
              <h3>Ship</h3>
              <p>
                Coordinate international shipping and logistics.
              </p>
            </div>

            <div className="process-item">
              <div className="process-number">05</div>
              <HandshakeIcon />
              <h3>Deliver</h3>
              <p>
                Deliver your products to the final destination.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* ───────────────── AMAZON FBA ───────────────── */}
      <section className="fba-section">
        <div className="container">

          <div className="fba-grid">

            <div className="fba-content">

              <span className="section-label">
                AMAZON FBA SOLUTIONS
              </span>

              <h2 className="section-heading">
                China to Amazon FBA
                <br />
                <span>Warehouse Delivery</span>
              </h2>

              <p>
                Selling on Amazon? We provide an end-to-end solution for
                businesses sourcing products from China and delivering them
                directly to Amazon FBA warehouses.
              </p>

              <p>
                From supplier coordination and inspection to packaging,
                shipping, customs support, and final warehouse delivery,
                Annapurna Axis helps simplify the entire process.
              </p>

              <div className="fba-points">

                <div>
                  <VerifiedIcon />
                  Supplier Coordination
                </div>

                <div>
                  <VerifiedIcon />
                  Product Inspection
                </div>

                <div>
                  <VerifiedIcon />
                  Export Packaging
                </div>

                <div>
                  <VerifiedIcon />
                  FBA Warehouse Delivery
                </div>

              </div>

              <Link to="/contact" className="btn btn-primary">
                Discuss Your Requirements
              </Link>

            </div>

            <div className="fba-visual">
              <div className="fba-card">
                <span>CHINA</span>
                <LocalShippingIcon />
                <span>AMAZON FBA</span>
              </div>
            </div>

          </div>

        </div>
      </section>


      {/* ───────────────── WHY US ───────────────── */}
      <section className="why-section">
        <div className="container">

          <span className="section-label center">
            WHY ANNAPURNA AXIS
          </span>

          <h2 className="section-heading center">
            A Partner You Can Rely On
          </h2>

          <div className="why-grid">

            <div className="why-card">
              <div className="why-icon">
                <HandshakeIcon />
              </div>
              <h3>Reliable Partnerships</h3>
              <p>
                We focus on building transparent and long-term relationships
                with clients and suppliers.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <VerifiedIcon />
              </div>
              <h3>Quality Focused</h3>
              <p>
                Quality inspection and supplier verification help reduce
                sourcing risks.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <LocalShippingIcon />
              </div>
              <h3>End-to-End Logistics</h3>
              <p>
                We coordinate the journey from supplier to your final
                destination.
              </p>
            </div>

            <div className="why-card">
              <div className="why-icon">
                <LocalOfferIcon />
              </div>
              <h3>Competitive Solutions</h3>
              <p>
                We work to provide practical sourcing and logistics solutions
                suited to your business requirements.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* ───────────────── CTA ───────────────── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">

            <div>
              <span className="section-label">
                LET'S WORK TOGETHER
              </span>

              <h2>
                Ready to Simplify Your Global Sourcing?
              </h2>

              <p>
                Tell us what you need. Our team can help you source,
                inspect, package, ship, and deliver your products.
              </p>
            </div>

            <div className="cta-actions">
              <Link to="/contact" className="btn btn-dark">
                Request a Quote
              </Link>

              <Link to="/services" className="btn btn-white">
                View Services
              </Link>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;